module.exports = __webpack_public_path__ + "02c5cba2c63d826b5885c87112282672.svg";